<ion-header>
  <ion-toolbar>
    <ion-title>Select user</ion-title>
    <ion-buttons slot="end">
      <ion-button fill="clear" (click)="dismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  @if(!isLoading) {
  <div class="ion-padding" *ngIf="team?.participants?.length; else noAdmins">
    <div class="heading">
      <p>{{ 'Which player are you?' | translate }}</p>
    </div>

    <ion-list>
      <ion-item
        button
        detail="false"
        *ngFor="let ta of nonPendingParticipants"
        (click)="onSelectPlayer(ta)"
      >
        <ion-avatar slot="start">
          <img
            *ngIf="ta?.person?.profile_image; else defaultAvatar"
            [src]="ta.person.profile_image"
            alt="Profile Image"
          />
        </ion-avatar>

        <ng-template #defaultAvatar>
          <ion-avatar>
            <ion-icon name="person-circle-outline" size="large"></ion-icon>
          </ion-avatar>
        </ng-template>

        <ion-label>
          {{ ta?.person?.first_name }} {{ ta?.person?.last_name }}
          <p>{{ ta?.person?.phone }}</p>
        </ion-label>

        <ion-checkbox
          slot="end"
          [checked]="selectedPlayerId === ta?.person?._id"
          (ionChange)="onSelectPlayer(ta)"
        ></ion-checkbox>
      </ion-item>
    </ion-list>
  </div>

  <ng-template #noAdmins>
    <ion-item>
      <ion-label>{{ 'No team players found.' | translate }}</ion-label>
    </ion-item>
  </ng-template>
  }

  @if(isLoading) {
  <div class="ion-padding" *ngFor="let item of [0, 1, 2]">
    <ion-skeleton-text animated style="width: 30%"></ion-skeleton-text>
    <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
    <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
  </div>
  }
</ion-content>
